import { Component, Prop, Vue } from "vue-property-decorator";

import { DashboardCard } from "../../models/DashboardCard";
import DashboardCardElement from "./../DashboardCardElement/DashboardCardElement.vue";

@Component({
  name: "DashboardCardList",
  components: { DashboardCardElement }
})
export default class DashboardCardList extends Vue {
  @Prop({ default: () => [] }) listCard!: DashboardCard[];
  @Prop({ default: () => false }) iconBig!: boolean;
}
